import Grid from 'components/Grid'
import ThingCard from 'components/ThingCard'
import { MbPagination, MbThingCard } from 'mintbase-ui'
import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { useActiveAuctionsController } from '../controllers/ActiveAuctions.controller'
import { MarketTabProps } from '../types/Marketplace.type'

const LoadingLists = ({ itemsPerPage }: { itemsPerPage }) => {
  const lists = Array.from(Array(itemsPerPage).keys())
  return (
    <>
      {lists.map(() => (
        <MbThingCard loading={true} key={''} cardInfo={null} />
      ))}
    </>
  )
}

const ActiveAuctions = (props: MarketTabProps) => {
  const { filter, page: initialPageIndex } = props

  const { data, loading, setCurrentPage, itemsPerPage, page, totalItems } =
    useActiveAuctionsController({
      filter,
      initialPageIndex,
    })

  const router = useRouter()

  const handleFilterChange = () => {
    router.replace(
      `/market?tab=auctions&orderby=${filter}&page=${initialPageIndex}`
    )
    window.scrollTo({ top: 0, behavior: 'smooth' })
    setCurrentPage(0)
  }

  useEffect(() => {
    handleFilterChange()
  }, [filter])

  return (
    <>
      <Grid>
        {loading && <LoadingLists itemsPerPage={itemsPerPage} />}
        {!loading &&
          data?.map((ele, index) => {
            return (
              <ThingCard
                key={`${ele.id}-${index}`}
                id={ele?.thing?.id || ''}
                title={ele?.thing?.metadata?.title || ''}
                coverImage={ele?.thing?.metadata?.media || ''}
                url={`/thing/${ele?.thing?.id}/auction`}
              ></ThingCard>
            )
          })}
      </Grid>
      <MbPagination
        currentPage={page + 1}
        hasLabel
        itemsPerPage={itemsPerPage}
        onPageChange={(nextPage) => setCurrentPage(nextPage - 1)}
        totalItems={totalItems}
      />
    </>
  )
}

export default ActiveAuctions
